import { useMeasurementStore } from '@/stores/measurement-store'

import { MeasurementVisibleComponent } from '../components/measurement-visible-component'
import { SOFA_CORE_ID } from '../constants/component-ids'

import type { SofaPlatformCore } from '../core-api'

export function setMeasurementVisible(core: SofaPlatformCore) {
  const scene = core.coreServices.sceneManager.scene
  const isCurrentlyVisible =
    scene.getComponent<MeasurementVisibleComponent>(SOFA_CORE_ID.MEASUREMENT_VISIBLE_COMPONENT)?.isVisible ?? false
  const willHaveState = !isCurrentlyVisible
  useMeasurementStore.setState({ isVisible: willHaveState })
  scene.addComponent(new MeasurementVisibleComponent(willHaveState))
}
